
import React from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useLanguage } from '@/contexts/LanguageContext';
import AdminSidebar from '@/components/admin/AdminSidebar';
import AdminHeader from '@/components/admin/AdminHeader';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AdminLayout = () => {
  const { user, profile } = useAuth();
  const { language, t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  if (!user || !profile || profile.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={`min-h-screen bg-background ${language === 'ar' ? 'rtl' : 'ltr'}`}>
      <div className="flex h-screen">
        <AdminSidebar />
        <div className="flex-1 flex flex-col overflow-hidden">
          <AdminHeader />
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-background p-6">
            <Outlet />
          </main>
        </div>
      </div>
      
      <Button
        variant="outline"
        onClick={() => navigate('/')}
        className="fixed bottom-6 left-6 z-50 flex items-center gap-2 shadow-lg hover:shadow-xl transition-shadow"
      >
        <ArrowLeft className="h-4 w-4" />
        {t('back_to_website', 'العودة للموقع', 'Back to Website')}
      </Button>
    </div>
  );
};

export default AdminLayout;
